(() => {
  const init = root => {
    const select = root.querySelector('#tch-subject');
    if (!select || select.dataset.ready) return;
    select.dataset.ready = 'true';
    const update = () => {
      root.querySelectorAll('[data-contact-fields]').forEach(group => {
        const active = group.dataset.contactFields.split(',').includes(select.value);
        group.hidden = !active;
        group.querySelectorAll('input').forEach(input => { input.disabled = !active; });
      });
    };
    select.addEventListener('change', update);
    root.querySelectorAll('[data-contact-subject]').forEach(link => {
      link.addEventListener('click', () => {
        select.value = link.dataset.contactSubject;
        update();
        select.focus({ preventScroll: true });
      });
    });
    update();
  };
  document.querySelectorAll('.tch').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.tch').forEach(init);
  });
})();
